export default __webpack_public_path__ + "static/upcity-logo-9232888c664e211f68e2662338c721fe.svg";